import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";

// Explicit-trigger AI copy improvement (Sarvam). Caps text at 300 chars.
export default function AiImproveButton({ text, field = "about", onImproved, testid }) {
    const [loading, setLoading] = useState(false);
    const trimmed = (text || "").trim();
    const disabled = loading || !trimmed || trimmed.length > 300;

    const improve = async () => {
        setLoading(true);
        try {
            const { data } = await api.post("/ai/improve", { text: trimmed.slice(0, 300), field });
            if (data?.improved) {
                onImproved(data.improved);
                toast.success("Improved with AI");
            }
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mt-1.5 flex items-center gap-2">
            <Button type="button" variant="ghost" size="sm" onClick={improve} disabled={disabled}
                className="glass rounded-full h-8 text-xs text-accent hover:text-accent" data-testid={testid}>
                {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin mr-1" /> : <Sparkles className="w-3.5 h-3.5 mr-1" />}
                Improve with AI
            </Button>
            <span className="text-[11px] text-muted-foreground">{trimmed.length}/300</span>
        </div>
    );
}
